import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getPartnerAgreementTypeTranslationKey(
	type: Enums<"organizationPartnershipAgreementType">,
): TranslationKey {
	switch (type) {
		case "hourly-rate":
			return "partners.hourly_rate";
		case "early-payment-discount":
			return "partners.early_payment_discount";
		case "early-payment-discount-payment-target":
			return "partners.early_payment_discount_payment_target";
		case "payment-target":
			return "partners.payment_target";
		case "service":
			return "partners.service";
	}
}
